import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";
import { getItem } from "../../../utils/storageHelper";

// Action Types
export const UNDO_SUCCESS = "UNDO_SUCCESS";
export const UNDO_ERROR = "UNDO_ERROR";

// Thunk Action Creator
export const undo = createAsyncThunk(
    "api/Task/undo",
    async (_, { dispatch }) => {

        const firebaseData = await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`);
        const user = JSON.parse(firebaseData);

        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.put(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/undo`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        // Store tasks for offline access
                        idb.storeTaskList(response.data.tasks || response.data);
                    }                }
                else {
                    throw new Error("Error undoing task");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: UNDO_SUCCESS,
                    payload: response.data
                });
            } else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: UNDO_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
            //.then(response => {
            //    dispatch({
            //        type: UNDO_SUCCESS,
            //        payload: response.data,
            //    });
            //    dispatch(getLatestTaskList());
            //})
            //.catch(error => {
            //    dispatch({ type: UNDO_ERROR, payload: error });
            //});
        } catch (error) {
            dispatch({ type: UNDO_ERROR, payload: error });
            await signOut();
        }
    }
);
